import useTrackPageView from "./useTrackPageView";
import type { Page } from "./types";

export default function TrackPageView({ page }: { page: Page }) {
  useTrackPageView(page);
  return null;
}
